// Money is handled server-side in integer cents. These helpers are display-only.
export function formatCents(cents, currency = "USD") {
  const symbol = { USD: "$", EUR: "\u20ac", GBP: "\u00a3", INR: "\u20b9", CAD: "$", AUD: "$" }[currency] || "$";
  return symbol + (Number(cents || 0) / 100).toLocaleString(undefined, {
    minimumFractionDigits: 2, maximumFractionDigits: 2,
  });
}

// Parse "$1,260.00" style input to cents without floating point drift.
export function dollarsToCents(input) {
  const clean = String(input).replace(/[^0-9.]/g, "");
  if (!clean) return 0;
  const [d, c = ""] = clean.split(".");
  const cents = (c + "00").slice(0, 2);
  return parseInt(d || "0", 10) * 100 + parseInt(cents, 10);
}

export function formatDate(iso) {
  if (!iso) return "—";
  const d = new Date(iso.length <= 10 ? iso + "T00:00:00" : iso);
  return d.toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" });
}

export function shortDate(iso) {
  if (!iso) return "—";
  const d = new Date(iso.length <= 10 ? iso + "T00:00:00" : iso);
  return d.toLocaleDateString(undefined, { month: "short", day: "numeric" });
}

export function todayISO() {
  return new Date().toISOString().slice(0, 10);
}
